module.exports = __webpack_public_path__ + "img/toastMsg.420ba7b0.png";